import { useEffect, useRef, useState } from "react";
import { getAuthUser } from "../../../services/auth";
import { useNavigate } from "react-router-dom";

import DBLeadTable from "./DBLeadTable";
import useDBLeadForm from "./useDBLeadForm";
import DBLeadModal from "./DBLeadModal";
import SidebarFilter from "./SidebarFilter";
import ImportModal from "./ImportModal";
import ChartLead from "./ChartLead";
import useDBLeadActions from "./useDBLeadActions";
import PaginationControl from "./PaginationControl";

export default function DatabaseLeads() {
  const [tableLoading, setTableLoading] = useState(false);
  const [subCategoryDisable, setSubCategoryDisable] = useState(true);
  const [productTypeDisable, setProductTypeDisable] = useState(true);
  const [getSubCategoryLoading, setGetSubCategoryLoading] = useState(false);
  const [getProductTypeLoading, setGetProductTypeLoading] = useState(false);

  const [filters, setFilters] = useState({});
  const [leads, setLeads] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [lookupCategory, setLookupCategory] = useState([]);
  const [lookupSubCategory, setLookupSubCategory] = useState([]);
  const [lookupTypeProduct, setLookupTypeProduct] = useState([]);
  const [lookupUsers, setLookupUsers] = useState([]);
  const [activeFilterMo, setActiveFilterMo] = useState("");
  const [chartData, setChartData] = useState({});
  const [showChart, setShowChart] = useState(false);

  const modalRef = useRef(null);
  const importModalRef = useRef(null);
  const fileInputRef = useRef();
  const navigate = useNavigate();
  const auth = getAuthUser();

  const {
    form,
    setForm,
    errors,
    validated,
    setValidated,
    validate,
    handleChange,
    handleSelectChange,
    resetForm,
  } = useDBLeadForm();

  const { onCategoryChange, onSubCategoryChange, editLoading, ...actions } =
    useDBLeadActions({
      auth,
      form,
      setForm,
      resetForm,
      validate,
      setValidated,
      filters,
      perPage,
      setLeads,
      setChartData,
      setTotalPages,
      setTotalData,
      setTableLoading,
      setSubCategoryDisable,
      setProductTypeDisable,
      setGetSubCategoryLoading,
      setGetProductTypeLoading,
      setLookupSubCategory,
      setLookupTypeProduct,
      setLookupCategory,
      setLookupUsers,
      modalRef,
      importModalRef,
      fileInputRef,
    });

  useEffect(() => {
    actions.fetchDBLeads(1, filters, perPage);
    actions.fetchLookupCategory();
    actions.fetchLookupUsers(activeFilterMo);
  }, [activeFilterMo]);

  const handleFilterMo = (moId) => {
    setActiveFilterMo(moId);

    actions.fetchLookupUsers(moId);
    actions.fetchDBLeads(1, { ...filters, moId }, perPage);
  };

  const handleFilter = (newFilters) => {
    setActiveFilterMo(newFilters.moId);
    actions.fetchLookupUsers();
    setFilters(newFilters);
    actions.fetchDBLeads(1, newFilters, perPage);
  };

  return (
    <div>
      <div className={showChart ? "d-block" : "d-none"}>
        <ChartLead chartData={chartData} />
      </div>
      <button
        className="btn btn-primary my-2"
        onClick={() => setShowChart((prev) => !prev)}
      >
        {showChart ? "Hide Chart" : "Show Chart"}{" "}
      </button>
      <div className="d-flex align-items-center mb-3">
        <label className="me-2 fw-bold">Filter by MO:</label>
        <select
          className="form-select w-25"
          value={filters.moId}
          onChange={(e) => handleFilter({ ...filters, moId: e.target.value })}
        >
          <option value="">All</option>
          {lookupUsers &&
            lookupUsers?.mos?.map((val) => (
              <option key={val.id} value={val.id}>
                {val.name}
              </option>
            ))}
        </select>
      </div>

      <div className="d-flex flex-wrap justify-content-between gap-2 mb-3">
        <div className="d-flex align-items-center gap-2">
          <label className="me-2">Tampilkan:</label>
          <select
            className="form-select d-inline-block w-auto"
            value={perPage}
            onChange={(e) => {
              const newSize = Number(e.target.value);
              setPerPage(newSize);
              setPage(1);
              actions.fetchDBLeads(1, filters, newSize);
            }}
          >
            {[50, 100, 500, 1000].map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
          <span className="ms-2">
            Page {page} of {totalPages} dari {totalData.toLocaleString("id-ID")}
          </span>
        </div>
        <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
          {!tableLoading &&
            (auth?.role === "super-user" ||
              auth?.role === "admin" ||
              (auth?.role === "mo" && auth.mo?.mo_id === activeFilterMo) ||
              (auth?.role === "tls" && auth.mo?.mo_id === activeFilterMo) ||
              (auth?.role === "sales" && auth.mo.mo_id == activeFilterMo)) && (
              <>
                <button
                  className="btn btn-primary"
                  onClick={actions.handleAddModal}
                >
                  <i className="fa-solid fa-plus"></i> Tambah Kontak
                </button>

                {/* <button
                  className="btn btn-warning text-white"
                  onClick={() => {
                    new Modal(importModalRef.current).show();
                  }}
                >
                  <i className="fa-solid fa-upload"></i> Import
                </button> */}

                <button
                  onClick={actions.handleExport}
                  className="btn btn-success"
                  disabled={actions.exportLoading}
                >
                  {actions.exportLoading ? (
                    "Mengekspor..."
                  ) : (
                    <>
                      <i className="fa-solid fa-file-download"></i> Export
                    </>
                  )}
                </button>
              </>
            )}

          <SidebarFilter
            onFilter={handleFilter}
            dataLookupUsers={lookupUsers}
            activeFilterMo={activeFilterMo}
            lookupCategory={lookupCategory}
            lookupSubCategory={lookupSubCategory}
            lookupTypeProduct={lookupTypeProduct}
            subCategoryDisable={subCategoryDisable}
            productTypeDisable={productTypeDisable}
            onCategoryChange={onCategoryChange}
            onSubCategoryChange={onSubCategoryChange}
            getSubCategoryLoading={getSubCategoryLoading}
            getProductTypeLoading={getProductTypeLoading}
          />
        </div>
      </div>
      <DBLeadTable
        leads={leads}
        tableLoading={tableLoading}
        editLoading={editLoading}
        onEdit={actions.handleEdit}
        onDelete={actions.handleDelete}
        page={page}
        perPageSize={perPage}
        activeFilterMo={activeFilterMo}
      />
      <PaginationControl
        page={page}
        totalPages={totalPages}
        totalData={totalData}
        onPrev={() => {
          const newPage = page - 1;
          setPage(newPage);
          actions.fetchDBLeads(newPage, filters, perPage);
        }}
        onNext={() => {
          const newPage = page + 1;
          setPage(newPage);
          actions.fetchDBLeads(newPage, filters, perPage);
        }}
      />

      <ImportModal
        modalRef={importModalRef}
        fileInputRef={fileInputRef}
        onImport={actions.handleImport}
        uploadProgress={actions.uploadProgress}
        uploading={actions.uploading}
      />
      <DBLeadModal
        productTypeDisable={productTypeDisable}
        subCategoryDisable={subCategoryDisable}
        getSubCategoryLoading={getSubCategoryLoading}
        getProductTypeLoading={getProductTypeLoading}
        onSubCategoryChange={onSubCategoryChange}
        onCategoryChange={onCategoryChange}
        handleSelectChange={handleSelectChange}
        lookupUsers={lookupUsers}
        lookupCategory={lookupCategory}
        lookupSubCategory={lookupSubCategory}
        lookupTypeProduct={lookupTypeProduct}
        auth={auth}
        modalRef={modalRef}
        form={form}
        editId={actions.editId}
        onChange={handleChange}
        onSubmit={actions.handleSubmit}
        submitLoading={actions.submitLoading}
        validated={validated}
        errors={errors}
        onCancelEdit={() => {
          actions.setEditId(null);
          resetForm();
        }}
      />
    </div>
  );
}
